import { RichUtils, EditorState } from 'draft-js';

import icons from 'styles/icons/icons.scss';
import { ToolbarPluginButton } from './complionToolbarPlugins';
import ComplionToolbarButton from './ComplionToolbarButton';

const BoldButtonComponent = ({ editorState, getEditorState, setEditorState }) => {
    const onClick = e => {
        e.preventDefault();
        setEditorState(RichUtils.toggleInlineStyle(getEditorState(), 'BOLD'));
    };
    const currentStyle = editorState.getCurrentInlineStyle();
    const active = currentStyle.has('BOLD');
    return (
        <ComplionToolbarButton onMouseDown={onClick} active={active} data-cy="standardButtons-BoldButton">
            <span className={icons.materialIcons}>format_bold</span>
        </ComplionToolbarButton>
    );
};

export const BoldButton = new ToolbarPluginButton({
    Component: BoldButtonComponent,
    key: 'bold',
    group: 'textModifiers'
});

const ItalicButtonComponent = ({ editorState, getEditorState, setEditorState }) => {
    const onClick = e => {
        e.preventDefault();
        setEditorState(RichUtils.toggleInlineStyle(getEditorState(), 'ITALIC'));
    };
    const currentStyle = editorState.getCurrentInlineStyle();
    const active = currentStyle.has('ITALIC');
    return (
        <ComplionToolbarButton onMouseDown={onClick} active={active} data-cy="standardButtons-ItalicButton">
            <span className={icons.materialIcons}>format_italic</span>
        </ComplionToolbarButton>
    );
};

export const ItalicButton = new ToolbarPluginButton({
    Component: ItalicButtonComponent,
    key: 'italic',
    group: 'textModifiers'
});


const UnderlineButtonComponent = ({ getEditorState, setEditorState }) => {
    const editorState = getEditorState();
    const onClick = e => {
        e.preventDefault();
        setEditorState(RichUtils.toggleInlineStyle(getEditorState(), 'UNDERLINE'));
    };
    const currentStyle = editorState.getCurrentInlineStyle();
    const active = currentStyle.has('UNDERLINE');
    return (
        <ComplionToolbarButton onMouseDown={onClick} active={active} data-cy="standardButtons-UnderlineButton">
            <span className={icons.materialIcons}>format_underline</span>
        </ComplionToolbarButton>
    );
};

export const UnderlineButton = new ToolbarPluginButton({
    Component: UnderlineButtonComponent,
    key: 'underline',
    group: 'textModifiers'
});

const UnorderedListButtonComponent = ({ editorState, getEditorState, setEditorState }) => {
    const onClick = e => {
        e.preventDefault();
        setEditorState(RichUtils.toggleBlockType(getEditorState(), 'unordered-list-item'));
    };
    const blockType = RichUtils.getCurrentBlockType(editorState);
    const active = blockType === 'unordered-list-item';
    return (
        <ComplionToolbarButton onMouseDown={onClick} active={active} data-cy="standardButtons-UnorderedListButton">
            <span className={icons.materialIcons}>format_list_bulleted</span>
        </ComplionToolbarButton>
    );
};

export const UnorderedListButton = new ToolbarPluginButton({
    Component: UnorderedListButtonComponent,
    key: 'bullets',
    group: 'blockModifiers'
});

const OrderedListButtonComponent = ({ editorState, getEditorState, setEditorState }) => {
    const onClick = e => {
        e.preventDefault();
        setEditorState(RichUtils.toggleBlockType(getEditorState(), 'ordered-list-item'));
    };
    const blockType = RichUtils.getCurrentBlockType(editorState);
    const active = blockType === 'ordered-list-item';
    return (
        <ComplionToolbarButton onMouseDown={onClick} active={active} data-cy="standardButtons-OrderedListButton">
            <span className={icons.materialIcons}>format_list_numbered</span>
        </ComplionToolbarButton>
    );
};

export const OrderedListButton = new ToolbarPluginButton({
    Component: OrderedListButtonComponent,
    key: 'numbers',
    group: 'blockModifiers'
});

const UndoButtonComponent = ({ editorState, getEditorState, setEditorState }) => {
    const onClick = e => {
        e.preventDefault();
        setEditorState(EditorState.undo(getEditorState()));
    };
    const disabled = editorState.getUndoStack().size === 0;
    return (
        <ComplionToolbarButton onMouseDown={onClick} disabled={disabled} data-cy="standardButtons-UndoButton">
            <span className={icons.materialIcons}>undo</span>
        </ComplionToolbarButton>
    );
};

export const UndoButton = new ToolbarPluginButton({
    Component: UndoButtonComponent,
    key: 'undo',
    group: 'control'
});

const RedoButtonComponent = ({ editorState, getEditorState, setEditorState }) => {
    const onClick = e => {
        e.preventDefault();
        setEditorState(EditorState.redo(getEditorState()));
    };
    const disabled = editorState.getRedoStack().size === 0;
    return (
        <ComplionToolbarButton onMouseDown={onClick} disabled={disabled} data-cy="standardButtons-RedoButton">
            <span className={icons.materialIcons}>redo</span>
        </ComplionToolbarButton>
    );
};

export const RedoButton = new ToolbarPluginButton({
    Component: RedoButtonComponent,
    key: 'redo',
    group: 'control'
});

